import { Button } from "@/components/ui/button";
import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";

const SentryTest = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-destructive">
            <AlertTriangle className="h-5 w-5" />
            Sentry Test Page
          </CardTitle>
          <CardDescription>
            This page is used to test Sentry error tracking. Clicking the button
            below will trigger a test error.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button
            variant="destructive"
            type="button"
            onClick={() => {
              throw new Error("Sentry Test Error");
            }}
          >
            Break the world
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default SentryTest;
